import { Component } from '@angular/core'
import { ReservationComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	selector: 'porto-bank-reservation-page',
	imports: [ReservationComponent],
	template: '<feature-porto-bank-reservation/>',
})
export class ReservationPageComponent {}
